import * as Sentry from "@sentry/react";

const DENIED = /permission-denied|Missing or insufficient permissions/;
// @firebase/logger prefixes its own lines with "[<ISO time>]  @firebase/<name>:"; the message follows.
const SDK_PREFIX = /^\[[^\]]*\]\s+@firebase\/[\w-]+:$/;
const seen = new Set<string>();

// Promote logged Firestore permission denials to Sentry, once per message per page load.
export function reportFirestoreDenials() {
  for (const level of ["error", "warn"] as const) {
    const original = console[level];
    console[level] = (...args: any[]) => {
      original(...args);
      try {
        const err = args.find((a) => a?.code === "permission-denied" || DENIED.test(String(a)));
        if (!err || !Sentry.getClient()) return;
        const label = SDK_PREFIX.test(String(args[0])) ? args[1] : args[0];
        const source = String(label).replace(/(?=[\w-]*\d)[\w-]{8,}/g, "#").slice(0, 120);
        if (seen.has(source)) return;
        seen.add(source);
        Sentry.captureException(new Error(`Firestore permission denied: ${source}`, { cause: err }), {
          tags: { "firestore.code": "permission-denied" },
          fingerprint: ["firestore-permission-denied", source],
        });
      } catch {}
    };
  }
}
